var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 6.97917C18.8438 6.97917 6.97917 18.8438 6.97917 33.5 6.97917 48.1562 18.8438 60.0208 33.5 60.0208 48.1562 60.0208 60.0208 48.1562 60.0208 33.5 60.0208 18.8438 48.1562 6.97917 33.5 6.97917ZM32.1042 13.9583C34.0583 13.9583 35.5938 15.4938 35.5938 17.4479 35.5938 19.4021 34.0583 20.9375 32.1042 20.9375 30.15 20.9375 28.6146 19.4021 28.6146 17.4479 28.6146 15.4938 30.15 13.9583 32.1042 13.9583ZM40.4792 53.0417 26.5208 53.0417 26.5208 48.8542 31.4062 48.8542 31.4062 27.9167 27.2188 27.9167 27.2188 23.7292 35.5938 23.7292 35.5938 27.9167 35.5938 48.8542 40.4792 48.8542 40.4792 53.0417Z",
    fill: "#DAE3F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/infoicon.c9fde3609f372c2f2743ce60b63cc40f.svg";
export { ForwardRef as ReactComponent };